// import { firebase, googleAuthProvider } from '../firebase/firebase';
import axios from 'axios';
import isEmpty  from 'lodash/isEmpty';
// import { history }  from '../routers/AppRouter'
import getAppConfigParm  from '../config/AppConfig';
// import { dispatch } from 'react-redux';

// Async action that kicks off a standard action to update redux store

// Action creator for when encountering application error
export const picAppError = (error = '') => ({
    type: 'PIC_APP_ERROR',
    error
});

// Action creator for when clearing application error
export const clearPicAppError = (error = '') => ({
    type: 'CLEAR_PIC_APP_ERROR',
    error: ''
});

// Action creator for changing the event list filter 
// export const updateEventListFilter = (eventListFilter) => ({
//     type: 'UPDATE_EVENT_LIST_FILTER',
//     filters: {eventListFilter}
// });


export const updateEventListFilter = (eventListFilter) => {
    console.log("INSIDE UPDATE EVENT LIST FILTER ACTION CREATOR WITH THIS PARAMETER ", eventListFilter)
    return {
        type: 'UPDATE_EVENT_LIST_FILTER',
        filters:  { eventListFilter }
    }
};


// WEBPACK FOOTER //
// ./src/actions/picapp.js